import cs from 'classnames';
import type { FC } from 'react';
import { Fragment } from 'react';
import { Breadcrumbs, Container } from '@/DesignSystem/Component';
import useIsLandscape from '@/DesignSystem/Hook/useIsLandscape';
import type { IBreadcrumbsProps } from '@/DesignSystem/Model/DataModel';
import { useDeviceType } from '@/Module/Core/Hook';
import { DeviceType } from '@/Module/Core/Model/Enum';
const DefaultLayoutBreadcrumb: FC<IBreadcrumbsProps> = ({
  className,
  noMargin,
  ...props
}) => {
  const deviceType = useDeviceType();
  const isLandscape = useIsLandscape();
  if (isLandscape) {
    return null;
  }
  const ContainerComponent = deviceType === DeviceType.DESKTOP ? Container : Fragment;
  return <div className={cs('bg-blueOne border-x-4 border-b-4 border-blueFive', className, !noMargin ? 'mb-4 md:mb-4 lg:mb-14' : null)} data-sentry-component="DefaultLayoutBreadcrumb" data-sentry-source-file="DefaultLayoutBreadcrumb.tsx">
      <ContainerComponent data-sentry-element="ContainerComponent" data-sentry-source-file="DefaultLayoutBreadcrumb.tsx">
        <Breadcrumbs {...props} data-sentry-element="Breadcrumbs" data-sentry-source-file="DefaultLayoutBreadcrumb.tsx" />
      </ContainerComponent>
    </div>;
};
export default DefaultLayoutBreadcrumb;